import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import { emptyArray } from 'ui-components/default-props/empty';

import { RETURNS } from '../../enums/csw-types';
import { UserSettingsOptions } from '../../enums/user-settings/user-settings-options';

import { doesServiceSupportSameDayFeature } from '../../hooks/use-is-service-local-delivery';
import { DateService } from '../../services/date-service';
import * as UserActions from '../../store/user/user.actions';
import { createUserSettingPrepayDutyAlert, getUserSettingPrepayDutyAlert } from '../duties-and-taxes/helpers';

export const createArrayValue = (value) => {
  if (Array.isArray(value)) {
    return value.filter((val) => val !== null);
  }
  if (!value) {
    return emptyArray;
  }
  return [value];
};

export const getShipDateFromEntity = (entityShipDate) => {
  const shipDate = entityShipDate ? new Date(entityShipDate) : new Date();
  const isShipdatePastOrToday = DateService.isSameOrBeforeToday(shipDate);
  return isShipdatePastOrToday ? new Date() : shipDate;
};

export const localDeliveryBlacklistFilterCB = (service) => !doesServiceSupportSameDayFeature(service);

export const useServiceFilters = ({ cswTypeId }) => {
  const filters = [];
  switch (cswTypeId) {
    case RETURNS:
      filters.push(localDeliveryBlacklistFilterCB);
      break;
    default:
      break;
  }
  return filters;
};

const hasBeenThirtyDays = (date) => {
  const thirtyDays = moment(date).add(30, 'days').toISOString();
  return moment().isSameOrAfter(thirtyDays, 'day');
};

export const useSaveUserSettingPrepayDutyAlert = () => {
  const dispatch = useDispatch();

  const prepayDutyAlert = useSelector((state) => getUserSettingPrepayDutyAlert(state));
  const setting = useSelector((state) =>
    createUserSettingPrepayDutyAlert(state, {
      ...UserSettingsOptions.prepayDutyAlert.settingValue,
    }),
  );

  const resetUserSettingPrepayDutyAlert = useCallback(() => {
    dispatch(UserActions.saveUserSetting(setting));
  }, [dispatch, setting]);

  useEffect(() => {
    if (prepayDutyAlert === undefined) {
      resetUserSettingPrepayDutyAlert();
    } else {
      const { createdPrepayDutyOn, dismissedOn } = prepayDutyAlert;
      if (hasBeenThirtyDays(createdPrepayDutyOn) || hasBeenThirtyDays(dismissedOn)) {
        resetUserSettingPrepayDutyAlert();
      }
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
